export const environment = {
    production: false,
    baseUrl: 'https://api-dev.marketplace.alphatrend.ai',
    referalUrl: 'https://dev.okstatetokens.com'
};
